import React from 'react';
import { PlusIcon } from '@heroicons/react/20/solid'; 

const CreateBrandPrompt = ({ handleOpen }) => {
  return (
    <div className="create-brand-prompt">
      <svg
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
        aria-hidden="true"
        className="create-brand-prompt__icon"
      >
        <path
          d="M9 13h6m-3-3v6m-9 1V7a2 2 0 012-2h6l2 2h6a2 2 0 012 2v8a2 2 0 01-2 2H5a2 2 0 01-2-2z"
          strokeWidth={2}
          vectorEffect="non-scaling-stroke"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
      <h3 className="create-brand-prompt__title">No brands available</h3>
      <p className="create-brand-prompt__text">Get started by creating a new brand.</p>
      <div className="create-brand-prompt__button-container">
        <button
          type="button"
          className="create-brand-prompt__button"
          onClick={handleOpen} 
        >
          <PlusIcon aria-hidden="true" className="create-brand-prompt__button-icon" />
          Create New Brand
        </button>
      </div>
    </div>
  );
};

export default CreateBrandPrompt;
